import { defineComponent as _defineComponent } from 'vue'
import type { PropType } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import type { SvgRendererProps } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Choice',
  props: {
    title: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disableChoice: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
      default: '',
    },
    svgRendererProps: {
      type: Object as PropType<SvgRendererProps>,
      required: true,
    },
    noBorder: {
      default: false,
    },
  },
  setup(__props) {

  

return { __sfc: true,SVGRenderer }
}

})